
import { ref } from 'vue'

const enabled = ref(import.meta.env.MODE === 'development')

export const log = (...args: unknown[]) => {
    if (enabled.value) console.log(...args)
}

export const infoLog = (...args: unknown[]) => {
    if (enabled.value) console.info(...args)
}

export const warnLog = (...args: unknown[]) => {
    if (enabled.value) console.warn(...args)
}

export const errorLog = (...args: unknown[]) => {
    if (enabled.value) console.error(...args)
}

